import React, { FC, ReactNode } from 'react'

import { ApolloClient, ApolloProvider, from } from '@apollo/client'

import cache from './cache'
import authLink from './links/auth'
import errorLink from './links/error'
import httpLink from './links/http'

interface Props {
  children: ReactNode
}

const GQLProvider: FC<Props> = ({ children }) => {
  const client = new ApolloClient({
    cache,
    link: from([errorLink, authLink, httpLink]),
  })

  return <ApolloProvider client={client}>{children}</ApolloProvider>
}

export default GQLProvider
